import { FC } from 'react';
import { logosData }  from '../configs';
import { Logo } from './Logo';

export const PartnersLogos: FC = () => {

  return (
    <div className="flex flex-wrap justify-center align-middle items-center mb-2">
      {logosData.partnersLogos.map((item, index) => (
        <div className="m-3 w-auto max-w-28 h-20 md:h-24 lg:h-28" key={index}>
          <Logo 
            path={item.path} 
            target="_blank" 
            rel="noreferrer" 
            src={item.src} 
            name={item.name} 
            className="h-full max-w-full object-contain" 
          />
        </div>
      ))}
    </div>
  );
};